import { AmountDue } from "./AmountDue";
import { Benefits } from "./Benefits";

export class PatientResponsibility{
     indvBenefits:Benefits = new Benefits(0,0,0,0,0,0,false,false,0,0,false,0);
     totalExpectedReimbursment:number = 0;
     totalSelfPayReimbursment:number = 0;
     amountDue:AmountDue = new AmountDue(0,0,0,0,'','');
     hasSecondaryIns:boolean = false;
}